import { graphql, useLazyLoadQuery, useRelayEnvironment } from 'react-relay';
import { useFetchQuery, useGlobalUser } from '@sparknz/journeys-common';
import { requestGuestLogin } from '@sparknz/universal-login-library';

import { useIdentityAccountsQuery } from '__generated__/useIdentityAccountsQuery.graphql';
import { useCaptcha } from '../../providers/CaptchaProvider';

const accountsListQuery = graphql`
  query useIdentityAccountsQuery {
    me {
      accountList {
        accountId
        segment
      }
    }
  }
`;

export default function useIdentity() {
  const relayEnvironment = useRelayEnvironment();
  const { getToken } = useCaptcha();
  const { authenticatedInfo, refetchUser } = useGlobalUser();

  const {
    me: { accountList },
  } = useLazyLoadQuery<useIdentityAccountsQuery>(accountsListQuery, {});

  const { fetch: fetchAccountList } = useFetchQuery<useIdentityAccountsQuery>(
    accountsListQuery,
    relayEnvironment,
  );

  function refetchLoginStatus() {
    return refetchUser();
  }

  function refetchAccountList() {
    return fetchAccountList({});
  }

  async function guestLogin() {
    try {
      const token = await getToken();
      return requestGuestLogin({
        captchaToken: token,
        redirectURL: window?.location.href,
      }).then(refetchLoginStatus);
    } catch {
      // eslint-disable-next-line no-console
      console.log('Execute hCaptcha not yet available');
      return Promise.reject();
    }
  }

  return {
    accountList,
    guestLogin,
    hasSparkId: authenticatedInfo?.hasSparkId,
    isGuest: authenticatedInfo?.isGuest,
    isLoggedIn: authenticatedInfo?.isLoggedIn,
    refetchLoginStatus,
    refetchAccountList,
  };
}
